import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Avertissements sur un logo tout juste téléversé.
 *
 * L'API renvoie des CODES (pas des phrases) : cloud-admin est traduit en quatre
 * langues, une phrase construite côté serveur arriverait en français chez un
 * organisateur néerlandophone.
 *
 * Volontairement affiché en bloc PERSISTANT et non en toast : le conseil est
 * actionnable (remplacer le logo), il doit rester lisible le temps de le faire.
 * Et jamais en rouge — le logo est accepté, il rendra simplement mal à un
 * endroit précis.
 */
export function LogoWarnings({ codes }: { codes?: string[] | null }) {
  const { t } = useTranslation();
  if (!codes || codes.length === 0) return null;

  return (
    <div className="mt-2 space-y-1">
      {codes.map((code) => (
        <p key={code} className="flex items-start gap-1.5 text-xs text-warning">
          <AlertTriangle size={13} className="mt-0.5 shrink-0" />
          <span>{t(`logoWarnings.${code}`, { defaultValue: '' })}</span>
        </p>
      ))}
    </div>
  );
}
